import { DOM } from '../shared/helpers/Document';


/*
 * This file manages the user keyboard input 
 * like escape, enter, ... 
 * ©tix02 – Xavier Mertens 
 *
 */
(() => {
	
	const b = document.body;
	
	const _onEscapeDown = () => {
		
		// Maybe close nav 
		if( b.classList.contains('primary-nav-shown') ) {
			const x = DOM.id('primary-nav-panel-close');
			if( x ) {
				x.dispatchEvent( new Event('click') );
			}
			return;
		}
		
		
		// Maybe close modal 
		if( b.classList.contains('has-modal') ) {
			const x = DOM.qs('.w-modal.is-shown .w-modal--close');
			if( x ) {
				x.dispatchEvent( new Event('click') );
			}
			return;
		}
	}
	
	
	b.addEventListener('keydown', event => {
		const key = event.code.toLowerCase();
		
		switch(key) {
			case 'escape': 
				_onEscapeDown();
				break;
			
			default: 
				// do nothing 
		}
	});
	
})();